var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53045 1.28331C5.69056 0.845723 6.30944 0.845724 6.46956 1.28332L7.3446 3.67484C7.41442 3.86567 7.59279 3.99526 7.79586 4.0027L10.3407 4.09589C10.8064 4.11294 10.9976 4.70154 10.6309 4.98904L8.62686 6.56027C8.46695 6.68565 8.39882 6.89533 8.4545 7.09076L9.15228 9.53988C9.27995 9.98801 8.77926 10.3518 8.39252 10.0919L6.27889 8.67143C6.11024 8.55808 5.88976 8.55808 5.72111 8.67143L3.60748 10.0919C3.22074 10.3518 2.72005 9.98801 2.84772 9.53988L3.5455 7.09076C3.60118 6.89533 3.53305 6.68565 3.37314 6.56027L1.36906 4.98904C1.00237 4.70154 1.19362 4.11294 1.65927 4.09589L4.20414 4.0027C4.40721 3.99526 4.58558 3.86567 4.6554 3.67484L5.53045 1.28331Z",
    fill: "#F5BF03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarImg);
export default __webpack_public_path__ + "static/media/starImg.8525077f16e32d20351da27f0d582648.svg";
export { ForwardRef as ReactComponent };